import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';
import Modal from 'react-responsive-modal';
//import AriaTabPanel from 'react-aria-tabpanel';
import ArtistLoginForm from '../components/ArtistLoginForm';

import { connect } from 'react-redux';
import Back from '../components/Back';
import AMLogo from '../assets/images/audition-magic-favicon.png';

import Uppy from "./uielements/uppy";
import "./uielements/uppy.css"
import agent from '../agent'

const config = {
  target: '#uppyHolder',
  inline: true,
  fieldName: 'medium[asset]',
  
  autoProceed: false,
  restrictions: {
    maxFileSize: 10000000 * 100, //1GB
    maxNumberOfFiles: 25,
    // minNumberOfFiles: 2,
    allowedFileTypes: ['.jpeg', '.jpg', '.png', '.gif', 'audio/*', '.pdf', '.doc', '.docx', '.mp4', 
                       '.mov', '.m4v', '.mp3', '.aiff', '.aif', '.aac', '.m4a', '.m4p', '.mpc', '.ogg', 
                       '.wav', '.wma', '.webm', '.flv', '.avi', '.wmv', '.mpeg', '.mpg', '.heiv', '.mkv',
                       '.webm'],
  },
  proudlyDisplayPoweredByUppy: false,
  metaFields: [
    { id: 'name', name: 'Name', placeholder: 'file name' },
    { id: 'caption', name: 'Caption', placeholder: 'describe what the image is about' },
    { id: 'medium[audition_ids]', name: 'Audition Id', placeholder: 'Audition ID' },
    { id: 'medium[project_id]', name: 'Project Id', placeholder: 'Project ID' }
  ],
  
  xhrUpload: {
    // endpoint: `'${agent.API_ROOT}/checkin/media`,
    // headers: {
    //   // 'authorization': `Token token="gBXHsKTyYtJ4LDhRbRyA", email="admin@am.com"`
    //   'authorization': `Token token="${agent.authToken.token || agent.authToken.authentication_token}", email="${agent.authToken.email}"`
    // },
    fieldName: 'medium[asset]',
    metaFields:['medium[audition_ids]', 'medium[project_id]', 'medium[uploader_id]'],
    limit: 1,
    timeout: 600 * 1000 // 600sec
  }
};

// const Header = ({clientDetails, projectDetails, artistInfo, token}) => 
//   <section id="brand-logo" className="section-brand-logo dashboard-header section">
//     <div className="row">
//     <div className="small-12 small-centered column text-center">
//       <img className="company-logo" src={clientDetails.logo_url || AMLogo} alt=""/>
//       <div className="post-relative with-name">
//         <h2>HI {artistInfo.artist.first_name}</h2>
//         <p className="top-title">Please upload the media required below for the {projectDetails.name}</p>
//       </div>
//     </div>
//     </div>
//    </section>

const Header = ({clientDetails, projectDetails, artistInfo, token}) => {
  let companyLogo = AMLogo
  let projectLogo = ""
  const topFix = {
    paddingTop: '2rem'
  }

  if (token && clientDetails && projectDetails) {
    companyLogo = clientDetails.logo_url
    projectLogo = projectDetails.cover_url
  } else if (clientDetails) {
    companyLogo = clientDetails.default_company_details.logo_url
    projectLogo = projectDetails.cover_url
  } else {
    projectLogo = ""
  }

  if (projectDetails) {
    return (
      <section id="brand-logo" className="section-brand-logo registration-header section">
       
        <div className="row text-center">
          <div className="small-12 medium-4 medium-offset-4 column">
            <div className="header-image-container">
              <img className="company-logo" src={companyLogo} alt="" />
            </div>
          </div>
          <div className="small-12 medium-4 column">
            <div className="header-image-container">
              { projectLogo && <img className="project-logo" src={projectLogo} alt="" /> }
            </div>
          </div>
        </div>

        <div style={topFix} className="row">
          <div className="small-12 small-centered column text-center with-name">
            { artistInfo && artistInfo.artist &&
              <h2>HI {artistInfo.artist.first_name}</h2>
            }
            { (!artistInfo || !artistInfo.artist) &&
              <h2>Hello</h2>
            }
            <p className="top-title">Please upload the media required below for the {projectDetails.name}</p>
          </div>
        </div>
      </section>
    )
  }
  return (
    <section id="brand-logo" className="section-brand-logo registration-header section">
      <div className="row">
      <div className="small-12 small-centered column text-center">
        <div className="header-image-container">
          <img className="am-logo" src={AMLogo} alt=""/>
        </div>
        <p className="top-title">Audition Magic Artist Registration</p>
      </div>
      </div>
    </section>
  )
}

class DirectMedia extends Component {
  constructor(props) {
    super(props);
    this.fileAdded = this.fileAdded.bind(this);
  }
  state = {
    enableNextButton: false,
    toogleSupportedMedia: false,
    login: false,
    isCheckingArtist: false,
    authentication_token: '',
    email: '',
    artistCl: "tabs-title is-active",
    agencyCl: "tabs-title",
    artistClPanel: "tabs-panel is-active",
    agencyClPanel: "tabs-panel",
    artistAria: true,
    agencyAria: false,
    project_id: 0,
    audition_ids: [],
    artist_id: 0,
    logout: false,
    showErrorModal: false,
    filesList: []
  }
  componentWillMount() {
    // const { artistValues } = this.props
    // this.setState({
    //   project_id: 0,  //artistValues.project_id,
    //   auditions_ids: [],  //artistValues.audition_ids,
    //   artist_id: 0  //artistValues.artist_id
    // })
  }
  componentDidMount() {
     const test = (this.state.authentication_token !== '' && this.state.email !== '')
      if (!test) {
        this.setState({
          login: false
        })
        return
      }
      const { authentication_token, email } = JSON.parse(localStorage.getItem('user_jwt')).meta
      const params  = {
        filename: '',
        content_type: '',
        file_size: ''
      }
      //unreachable part of the code
      this.initializeUppy(authentication_token, email, 0, [], 0)
  }
  componentDidUpdate() {
    
  }
  async componentWillReceiveProps(nextProps) {  
    console.log('next-props', nextProps)
    if (nextProps.publicArtist) {
      if (nextProps.publicArtist.message != null) {
        this.setState({
          showErrorModal: true
        })
        return;
      }
      const authentication_token = nextProps.publicArtist.meta.authentication_token
      const email = nextProps.publicArtist.meta.email;
      let auds = nextProps.publicArtist.auditions;
      let aud = auds.find(k => k.id == this.props.match.params.id);
      if (aud) {
        window.localStorage.setItem('artist_jwt', JSON.stringify(nextProps.publicArtist));
        agent.setToken(nextProps.publicArtist.meta)

        this.setState({
          authentication_token: authentication_token, //might not in use
          email: email,                               //might not in use
          project_id: aud.project_id,
          audition_ids: [aud.id], //auds.map((data) => { return data.id }),
          artist_id: aud.artist_id
        })

        let project_id = aud.project_id
        let artist_id = aud.artist_id
        let files = await agent.Project.mediaForArtist(project_id, artist_id)

        this.setState({filesList: files.media})

        this.initializeUppy(authentication_token, email, aud.project_id, [aud.id], aud.artist_id)
      }
      else {
        this.setState({
          showErrorModal: true
        })
      }
    }
  }

  initializeUppy (authentication_token, email, project_id, audition_ids, artist_id) {
    // let auditions_ids = this.state.auditions_ids
    // let project_id = this.state.project_id
    
    config.auditions_ids = audition_ids
    config.project_id = project_id

    config.xhrUpload.endpoint = `${agent.API_ROOT}/checkin/media`
    config.xhrUpload.headers = {
      'authorization': `Token token="${authentication_token}", email="${email}"`
    }
    
    this.uppy = Uppy(config);

    // Before initializing the listeners, try to add the 
    // files under the audition

    let uppy = this.uppy;
    uppy.cancelAll()
    this.setState({ enableNextButton: (this.state.filesList.length > 0) });
    this.state.filesList.forEach(function(media) {
      fetch(media.thumbnail).then((response) => response.blob()).then((blob) => {
        let fid = uppy.addFile({
          name: media.filename,
          type: media.content_type,
          data: blob,
          meta: { on_server: true },
          remote: true
        });

        uppy.setFileState(fid, { 
          progress: { uploadComplete: true, uploadStarted: new Date(), percentage: 100, bytesTotal: media.file_size, bytesUploaded: media.file_size } 
        })
      });
    });

    this.uppy.on('file-added', this.fileAdded)

    this.uppy.on('upload-success', this.onSuccess)
    this.uppy.on('complete', (result) => this.onComplete(result))
  }

  fileAdded (file) {
    console.log("fileadded: ", file, this.state.audition_ids)
    let audition_ids = this.state.audition_ids
    let project_id = this.state.project_id
    let artist_id = this.state.artist_id

    this.uppy.setFileMeta(file.id, {
      "medium[audition_ids]": audition_ids,
      "medium[project_id]": project_id,
      "medium[uploader_id]": artist_id,

    })
  }

  onComplete = (result) => {   
    console.log('successful files:', result.successful)
    console.log('failed files:', result.failed)

    let aud_ids = this.state.audition_ids;
    // agent.Artist.finalizeFiles(aud_ids).then(({result}) => { this.setState({enableNextButton: true}) } )
    // aud_ids.forEach(function(aud_id) {
    //   agent.Artist.finalizeFiles(aud_id)
    // })
    this.setState({ enableNextButton: true });

  }

  onSuccess(file, resp) {
    let url = new URL(resp.uploadURL);
    let pieces = url.pathname.split('/');
    let mediumID = pieces[pieces.length - 2];

    agent.Artist.finalizeFiles(mediumID);
  }

  onSupportedMedia() {
    if (this.state.toogleSupportedMedia) {
      this.setState({
        toogleSupportedMedia: false
      })
    } else {
      this.setState({
        toogleSupportedMedia: true
      })
    } 
  }

  getInitialValues () {
    const username = this.state.thisIsMeArtist ? this.state.thisIsMeArtist.email : ""
    return {
      username: username
    }
  }

  onCloseModal = () => {
    console.log('onCloseModal')
    // this.setState({ login: false });
  }

  onCloseErrorModal = () => {
    // this.setState({
    //   showErrorModal: false
    // })
    // console.log('onCloseErrorModal')
    // this.props.history.push({
    //   pathname: this.props.location.pathname,
    //   search: this.props.location.search,
    //   state: this.props.location.state
    // })
    // this.props.history.push({
    //   pathname: '/'
    // })
    window.location.reload();
  }

  toggleLogin = (flag) => {
    if (flag === 'artist')
      this.setState({
        artistCl: "tabs-title is-active",
        agencyCl: "tabs-title",
        artistClPanel: "tabs-panel tabs-add is-active",
        agencyClPanel: "tabs-panel tabs-add",
        artistAria: true,
        agencyAria: false
      })
    if (flag === 'agency')
      this.setState({
        artistCl: "tabs-title",
        agencyCl: "tabs-title is-active",
        artistClPanel: "tabs-panel tabs-add",
        agencyClPanel: "tabs-panel tabs-add is-active",
        artistAria: false,
        agencyAria: true
      })
  }

  push_login = values => {
    const { username, password } = values
    const projectToken = new URLSearchParams(this.props.location.search).get('token');
    
    if (username && password) {
      this.props.publicLogin(username, password).then((res) => {
        this.setState({ 
          login: true,
          isCheckingArtist: true
        })
      })
      const project = agent.Project.projectById(projectToken)
      const company = project.then( ({project}) => agent.My.info(project.company_token) )
      this.props.onLoad(
      Promise.all([
          project,
          company
        ])
      )
      return
    }
  }

  onSubmit = values => {
    console.log('onSubmit') //not in used
  }

  logout = () => {

    let aud_ids = this.state.audition_ids;
    aud_ids.forEach(function(aud_id) {
      agent.Artist.finalizeFiles(aud_id)
    })
    
    console.log('logout', 'Thank you for uploading...')
    window.localStorage.removeItem('artist_jwt')
    this.setState({ logout: true })
  }

  redirect = () => {
    this.props.history.push({
      pathname: '/'
    })
  }

  nl2br (str, is_xhtml) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  }

  render() {
    const { handleSubmit, previousPage, nextPage, pristine, submitting, media, publicArtist, errors, location, project, company } = this. props
    const { enableNextButton, artistCl, agencyCl, artistAria, agencyAria, artistClPanel, agencyClPanel } = this.state
    const projectToken = new URLSearchParams(this.props.location.search).get('token');
    console.log('render-directmedia', this.props)
    return (
      <div>
        <div>
          <Modal classNames={{ modal: 'medium-modal sample-me' }} open={!this.state.login} onClose={this.onCloseModal} little>
            <div id="login-modal">
              <div id="direct-media-modal">
                <ul className="tabs" data-tabs id="login-tabs">
                  <li className={artistCl}><a href="#artist_panel" aria-selected={artistAria} onClick={e => this.toggleLogin("artist")}>TALENT</a></li>
                </ul>
                <div className="tabs-content" data-tabs-content="login-tabs">
                  <div>
                    <h2 className="modal-title">TO ACCESS THIS PAGE</h2>
                    <p className="modal-description">Please enter your details below to proceed</p>
                  </div>
                  <div className={artistClPanel} id="artist_panel">
                    <ArtistLoginForm 
                      isCheckingArtist={this.state.isCheckingArtist}
                      onSubmit={this.push_login}
                      initialValues={this.getInitialValues()}
                      errors={errors} />
                  </div>
                  <div className={agencyClPanel} id="agency_panel">
                    
                  </div>
                </div>
                
              </div>
              <div className="clearfix"></div>
            </div>
          </Modal>
          <Modal classNames={{ modal: 'medium-modal' }} open={this.state.showErrorModal} onClose={this.onCloseErrorModal} little>
              <h2 className="reveal-title">Error occured</h2> 
              
              <p>You currently don’t have access to this Artist’s direct media upload page, please ensure you have the correct link or authority to access this page</p>
              
              <div className="clearfix"></div>
              <button className="button float-left" onClick={this.onCloseErrorModal}>Close</button>
          </Modal>
        </div>
        {
          this.state.login && !errors ?
            <Header 
              clientDetails={this.props.company} 
              projectDetails={this.props.project} 
              artistInfo={this.props.publicArtist}
              token={projectToken} 
              success="true"/> : <p></p>
        }
        {
          this.state.logout ?
            <section className="section gray-bg public-registration">
              <div id="logout-modal">
                <h2>Thank you for submitting your media for this project.</h2>
                <h6 className="subheader">Click close below to redirect to homepage.</h6>
                <button className="button button-adj" onClick={this.redirect}>Close</button>
              </div>
              <div className="clearfix"></div>
            </section> :
            <form onSubmit={this.onSubmit} className="checking-availability-form">
              <section className="section gray-bg public-registration">
                <div className="grid-x align-center">
                  <div className="small-12 medium-10 large-8 cell">


                    <div className="row small-12 media-wrapper">
                      <div className="column small-9 upload-media">
                        <div className="row small-8 align-right">
                          <h5>Upload Media</h5>
                          {
                              <p>You are required to upload Audition Media for this job:</p>
                          }
                          <p className="upload-supported-media">Please see a list of <a className="supported-media" onClick={e => this.onSupportedMedia()}>supported media files</a> you can upload</p>
                          {
                            this.state.toogleSupportedMedia ?
                              <div className="toogle-support row small-12">
                                <div className="column"><b>Image:</b> png, jpg, jpeg, bmp, gif</div>
                                <div className="column"><b>Audio:</b> mp3, aac, m4a, wav, wma</div>
                                <div className="column"><b>Video:</b> flv, avi, wmv, mov, mp4, mpg, mpeg, m4v, heiv, webm, mkv, m4v+gif</div>
                                <div className="column"><b>Document:</b> pdf, doc, docx</div>
                              </div> : <div></div>
                          }
                          {
                            this.props.project && this.props.project.video_instruction && this.props.project.video_instruction.length &&
                              <p><strong>Upload instructions:</strong> <div dangerouslySetInnerHTML={{ __html: this.nl2br(this.props.project.video_instruction) }} /></p>
                          }
                        </div>
                      </div>
                      <div className="column small-3 taped-media">
                        <p>Need help with your self tape media? <a href="https://www.auditionmagic.com/selftaping/" target="_blank"><b>click here</b></a></p>
                        <p>Download handbreak to reduce file size: <a href="https://handbrake.fr/downloads.php" target="_blank"><b>click here</b></a></p>
                        <p>To convert HEIC / HEIF to JPG or supported formats: <a href="https://www.howtogeek.com/666363/how-to-convert-heic-photos-to-jpg-on-iphone-and-ipad/" target="_blank"><b>follow instructions mentioned here.</b></a></p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="column">
                        <div className="uppy-adjustments uppy-text" id="uppyHolder"></div>
                        <div className="text-center" id="pubreg-media-upload-btn"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="section">
                <div className="grid-x align-center">
                  <div className="small-12 cell text-center">
                    {
                      previousPage &&
                      <button 
                        className="button primary previous" 
                        type="button" 
                        onClick={previousPage} >Previous</button>
                    }

                    {
                      nextPage 
                      ? <button className="button primary next" type="submit" disabled={!enableNextButton}>Next</button>
                      : <button className="button primary" 
                          type="button"
                          onClick={this.logout}
                          disabled={!enableNextButton}>
                            {submitting ? 'Submitting your upload...' : 'Submit' }
                        </button>
                    }
                  </div>
                </div>
              </section>
            </form>
        }
        
      </div>
    )
  }
}

DirectMedia = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(DirectMedia)


const mapStateToProps = state => ({
  artistValues: getFormValues('checkinWizard')(state),
  publicArtist: state.common.publicArtist,
  project: state.projects.project,
  company: state.projects.company
});

const mapDispatchToProps = dispatch => ({
  publicLogin: (username, password) =>
    dispatch({ 
      type: 'PUBLIC_ARTIST_LOGIN', 
      payload: agent.Artist.login(username, password) }),
    onLoad: payload =>
    dispatch({ type: `PUBLIC_REGISTRATION_PAGE`, payload: payload })
});


export default connect(mapStateToProps, mapDispatchToProps)(DirectMedia)


// WEBPACK FOOTER //
// ./src/components/DirectMedia.js